<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-title>Prescrizioni e prenotazioni esami</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="onClose()">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div>
    <ion-grid class="ion-margin">
      <ion-row>
        <ion-col>
          <ion-item>
            <ion-icon slot="start" size="large" color="danger" [src]="'alert-circle-outline' | getIcon"
                      class="ion-margin-end">
            </ion-icon>
            <ion-text>
              <p>
                Attenzione, In ogni ricetta possono essere prescritte fino a un massimo di otto prestazioni,
                cliccare sul pulsante del gruppo per generare la ricetta con le 8 prestazioni.
                E' possibile premere il pulsante aggiorna per sapere quale prestazione non è ancora stata eseguita.
              </p>
            </ion-text>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div *ngFor="let prescription of prescriptionUrl; let i = index;">
      <ion-accordion-group expand="inset">
        <ion-accordion toggleIcon="caret-down-circle" toggleIconSlot="end">
          <ion-item slot="header" color="light">
            <ion-label>{{prescription.nome}}</ion-label>
            <ion-button color="secondary" (click)="prescrivi(prescription, $event)">
              Prescrivi
            </ion-button>
            <ion-button color="secondary" (click)="prenota(prescription, $event)">
              Prenota
            </ion-button>
          </ion-item>

          <div *ngFor="let prestazioni of prescription.prestazioni" class="margin-left" slot="content">
            <ion-item>
              <ion-label class="ion-text-wrap">{{prestazioni}}
              </ion-label>
            </ion-item>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </div>


  </div>

</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="danger" (click)="onClose()">Annulla</ion-button>

      <ion-button color="primary" (click)="refresh()">
        <ng-container>
          <span>Aggiorna</span>
          <ion-icon slot="end" name="refresh-outline"></ion-icon>
          <ion-spinner slot="end" *ngIf="loading$ | async" color="secondary"></ion-spinner>
        </ng-container>
      </ion-button>

    </ion-buttons>
  </ion-toolbar>
</ion-footer>